import { publish } from 'bv-services/internal-event-bus';
import { onChange } from 'MainSettings/duck';
import handleFailedUpdate from 'MainSettings/handlers/handle_failed_update';
import { submitPreferences } from './api';
import { settingsUpdateStart, settingsUpdateSuccess, settingsUpdateError } from './duck';

export const onToggle = (newValue) => (dispatch) => {
  dispatch(settingsUpdateStart());
  publish('BetslipAcceptAllPriceChanges::start');
  submitPreferences({
    'betting_settings[acceptable_price_change_pct]': newValue,
  }).then(() => {
    publish('BetslipAcceptAllPriceChanges::end');
    dispatch(settingsUpdateSuccess(newValue));
    dispatch(onChange({
      target: {
        name: 'betting_settings[acceptable_price_change_pct]',
        type: 'text',
        value: newValue,
      },
    }));
  }).catch(() => {
    dispatch(settingsUpdateError());
    handleFailedUpdate();
  });
};
